import { render, staticRenderFns } from "./KLineChart.vue?vue&type=template&id=810706e0&scoped=true"
import script from "./KLineChart.vue?vue&type=script&lang=js"
export * from "./KLineChart.vue?vue&type=script&lang=js"
import style0 from "./KLineChart.vue?vue&type=style&index=0&id=810706e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810706e0",
  null
  
)

export default component.exports